import { render, staticRenderFns } from "./EditTexture.vue?vue&type=template&id=340a491e&"
import script from "./EditTexture.vue?vue&type=script&lang=js&"
export * from "./EditTexture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports